// Override console methods to send errors to terminal via Vite middleware
const sendToTerminal = (level: string, ...args: any[]) => {
  const message = args.map(arg => 
    typeof arg === 'object' ? JSON.stringify(arg, null, 2) : String(arg)
  ).join(' ');
  
  // Send to our Vite endpoint
  fetch('/__console_log', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ level, message, timestamp: new Date().toISOString() })
  }).catch(() => {}); // Silently fail if endpoint not available
};

// Store original methods
const originalError = console.error;
const originalWarn = console.warn;
const originalLog = console.log;

// Override console methods
console.error = (...args: any[]) => {
  originalError(...args);
  sendToTerminal('ERROR', ...args);
};

console.warn = (...args: any[]) => {
  originalWarn(...args);
  sendToTerminal('WARN', ...args);
};

console.log = (...args: any[]) => {
  originalLog(...args);
  sendToTerminal('LOG', ...args);
};

// Catch unhandled errors
window.addEventListener('error', (event) => {
  sendToTerminal('ERROR', `Uncaught: ${event.message} at ${event.filename}:${event.lineno}`);
});

window.addEventListener('unhandledrejection', (event) => {
  sendToTerminal('ERROR', `Unhandled Promise Rejection: ${event.reason}`);
});
